"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Sanitized = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _intercomSanitizer = require("@intercom/intercom-sanitizer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Sanitized = function Sanitized(props) {
  var cleanString = (0, _intercomSanitizer.sanitizeHtml)(props.html);
  return /*#__PURE__*/_react["default"].createElement(props.element, {
    className: props.className,
    dangerouslySetInnerHTML: {
      __html: cleanString
    },
    id: props.id,
    style: props.style,
    "data-testid": props["data-testid"]
  });
};
exports.Sanitized = Sanitized;
Sanitized.defaultProps = {
  html: ""
};
Sanitized.propTypes = {
  html: _propTypes["default"].string.isRequired,
  element: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].elementType]).isRequired,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  style: _propTypes["default"].any,
  "data-testid": _propTypes["default"].string
};
Sanitized.defaultProps = {
  element: "span"
};
var _default = Sanitized;
exports["default"] = _default;